/**
 * True when the host element lives inside the currently visible Ionic page.
 * Hidden stacked pages keep `ion-page-hidden` on their `ion-page` wrapper.
 */
export function isHostOnActiveIonPage(host: HTMLElement): boolean {
  const page = host.closest("ion-page");
  if (!page) {
    return true;
  }
  return !page.classList.contains("ion-page-hidden");
}
